import { createContext, Dispatch } from 'react';
import {
  Company,
  CreateProcessRequestInput,
  FileData,
  ForeignNational,
  JobDescription,
  ProcessRequestState,
} from 'API';
import { Updater } from 'use-immer';

type Props = {
  activePanel: ProcessPanelName;
  emailIsTaken: boolean;
  isExistingJob?: boolean;
  goToPanel: (name: ProcessPanelName) => void;
  panelNames: Array<ProcessPanelName>;
  process: CreateProcessRequestInput;
  resume?: FileData,
  titleIsTaken: boolean;
  selectedCompany?: Company,
  selectedJob?: JobDescription,
  selectedNational?: ForeignNational,
  setActivePanel: Dispatch<ProcessPanelName>;
  setEmailIsTaken: Dispatch<boolean>;
  setIsExistingJob: Dispatch<boolean>;
  setProcess: Updater<CreateProcessRequestInput>;
  setResume: Dispatch<FileData | undefined>;
  setSelectedCompany: Dispatch<Company | undefined>,
  setSelectedJob: Dispatch<JobDescription | undefined>,
  setTitleIsTaken: Dispatch<boolean>;
  setUploadedDescription: Dispatch<FileData | undefined>,
  uploadedDescription?: FileData,

};

const CreateProcessContext = createContext<Props>({
  activePanel: 'start',
  goToPanel: () => { },
  panelNames: [],
  process: {
    slug: '',
    requestDate: '',
    state: ProcessRequestState.REQUESTED,
  },
  resume: undefined,
  setResume: () => { },
  setActivePanel: () => {},
  setProcess: () => {},
  selectedNational: undefined,
  selectedJob: undefined,
  setSelectedJob: () => {},
  selectedCompany: undefined,
  setSelectedCompany: () => {},
  isExistingJob: undefined,
  setIsExistingJob: () => { },
  emailIsTaken: false,
  setEmailIsTaken: () => { },
  titleIsTaken: false,
  setTitleIsTaken: () => {},
  uploadedDescription: undefined,
  setUploadedDescription: () => { },
});

export default CreateProcessContext;
